import { SendingState, StepName, StepStatus } from './types'

export function getIsPendingStep(sendingState: SendingState | null, step: StepName) {
  return sendingState?.name === step && sendingState?.status === StepStatus.PENDING
}
